<template>
  <div class="app-container">
    <div class="tb" style="height: 100%">
      <div class="main tb">
        <div class="main" style="margin-top: 20px;">
          <el-table :data="table.data" height="700px" border
                    :header-cell-style="{background:'#fafafa',color:'#000000'}" v-loading="tableLoading">
            <el-table-column show-overflow-tooltip fixed="left" label="序号" type="index" width="55"
                             align="center"/>
            <el-table-column show-overflow-tooltip label="合作方" align="center"
                             prop="name"></el-table-column>
            <el-table-column show-overflow-tooltip label="总套数" align="center"
                             prop="totalHouses"></el-table-column>
            <el-table-column show-overflow-tooltip label="总间数" align="center"
                             prop="totalRooms"></el-table-column>
            <el-table-column show-overflow-tooltip label="空置间数" align="center"
                             prop="totalFreeRooms"></el-table-column>
            <el-table-column show-overflow-tooltip label="操作" width="210" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="toDetail(scope.row)">明细</el-button>
                <el-button type="text" style="color: #ff4949;" @click="deleteData(scope.row.id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import {statistics} from "@/api/cooperate";
import {deleteCooperateData} from "@/api/user";

export default {
  data() {
    return {
      table: {
        data: []
      },
      loading: false,
      tableLoading: false
    }
  },
  mounted() {
    this.statistics()
  },
  methods: {
    deleteData(id) {
      this.$confirm('此操作将永久删除合作方信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteCooperateData(id).then(response => {
          if (response.code == 200) {
            // 操作成功
            this.$message.success('操作成功!')
            this.statistics()
          } else {
            // 操作失败
            this.$message.error(response.data)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 搜索框查询
    statistics() {
      statistics().then(response => {
        if (response.code == 200) {
          // 查询成功
          this.table.data = response.data
        } else {
          // 查询失败
          this.$message.error('查询失败!')
        }
        this.tableLoading = false
      })
    },
    toDetail(row) {
      this.$router.push('/cooperateHouse?cooperateId=' + row.id)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/back/cooperateManage.vue